<script lang="ts" setup>
import type { IProps } from './solutions-imageWithText.types'

withDefaults(defineProps<IProps>(), {
  layout: 'default',
})
</script>

<template>
  <UiSection>
    <div class="image-with-text">
      <UiHeader
        :header="header"
        :subheader="subheader"
        position="center"
      />
      
      <div
        :class="[
          'image-with-text__layout',
          `image-with-text__layout--${layout}`
        ]"
      >
        <img
          class="image-with-text__img"
          :src="image.src"
          :width="image.width"
        >

        <div
          v-if="text"
          class="image-with-text__content"
        >
          <p class="image-with-text__text image-with-text__text--first">
            {{ text }}
          </p>

          <div
            v-if="textSecond"
            class="image-with-text__text image-with-text__text--second"
            v-html="textSecond"
          />
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.image-with-text {
  $root: &;

  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 115.2rem;
  width: 100%;
  margin: 0 auto;

  @include atXL {
    max-width: 134rem;
  }

  &__layout {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__img {
    display: block;
    max-width: 100%;
    margin: 3.2rem auto;
    border-radius: 1.6rem;

    @include atM {
      margin: 6.4rem auto 5.6rem auto;
    }
  }

  &__content {
    max-width: 110rem;
    width: 100%;
    margin: 0 auto;
    @include atM {
      display: flex;
      gap: 8rem;
    }
  }

  &__text {
    font-weight: 500;
    text-align: center;

    @include atM {
      text-align: left;
    }
  }

  &__text--first {
    margin-bottom: 1.6rem;
    font-size: 2rem;
    line-height: 2.8rem;

    @include atM {
      margin: 0;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__text--second {
    font-size: 1.6rem;
    line-height: 2.4rem;

    @include atM {
      font-size: 1.8rem;
    }
  }
}
</style>
